function initHeaderSearch() {
  const component = document.querySelector('predictive-search-component');
  if (!component) return;

  // 拦截 fetch，去掉语言前缀
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('/search/suggest')) {
      url = url.replace(/\/[a-z]{2}(-[a-zA-Z]{2,4})?\/search\/suggest/, '/search/suggest');
    }
    return originalFetch.call(this, url, options);
  };

  const waitForRefs = setInterval(() => {
    const input = component.refs?.searchInput;
    if (!input) return;
    clearInterval(waitForRefs);

    const dropdown = component.querySelector('.predictive-search-dropdown');

    const showDropdown = () => { if (dropdown) dropdown.style.display = 'block'; };
    const hideDropdown = () => { if (dropdown) dropdown.style.display = 'none'; };

    // 监听输入
    input.addEventListener('input', (event) => {
      component.search(event);
      if (input.value.trim().length > 0) showDropdown();
      else hideDropdown();
    });

    // 监听搜索结果更新后强制显示
    const observer = new MutationObserver(() => {
      if (input.value.trim().length > 0) showDropdown();
    });
    observer.observe(component.querySelector('[data-search-results]'), {
      childList: true,
      subtree: true
    });

    input.addEventListener('keydown', (event) => {
      if (component.onSearchKeyDown) component.onSearchKeyDown(event);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length > 0) showDropdown();
    });

    // 点击外部隐藏
    document.addEventListener('click', (e) => {
      if (!component.contains(e.target)) hideDropdown();
    });
  }, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderSearch);
} else {
  initHeaderSearch();
}
